import actionTypes from '../actions/types'
import merge from 'lodash/merge'

const content = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.REPLACE_CONTENT:
      return merge({}, state, action.payload)
    case actionTypes.REMOVE_CONTENT:
      return merge({}, state, action.payload)
    case actionTypes.SWITCH_LAYOUT_PRESET:
      return merge({}, state, action.payload)
    default:
      return state
  }
}

export default content


// WEBPACK FOOTER //
// ./app/javascript/app/site/reducers/content.js